export default "__VITE_ASSET__4QoB4Qq5__"